var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import * as pageSelectors from './selectors';
import * as pageActions from './actions';
import injectReducer from '../../utils/injectReducer';
import reducer from './reducer';
import ConditionsModal from '../../components/ConditionsModal';
import { P } from '../../components/UI-helpers/typography';
import { Button } from '@appspotr/ui-kit';
import Breadcrumbs from '../../components/OrgBreadcrumbs';
import { DataPrivacyBox, LatestPolicy, PolicyWrapper, BackContainer, PolicyListTitle, BackContainerBox, PolicyListContent, DataPrivacyWrapper, LatestPolicyDescription, LatestPolicyDescriptionWrapper, LatestPolicyIndicator, LatestPolicyWrapper, PasswordContentWrapper, } from './styles';
import { PageWrapper, PageHeader, PageContent, PageHeaderTitle, } from '../../components/Page';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
var DEFAULT_POLICY = {
    name: '',
    created_at: '',
    description: '',
};
var PrivacyPolicyList = /** @class */ (function (_super) {
    __extends(PrivacyPolicyList, _super);
    function PrivacyPolicyList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            policy: DEFAULT_POLICY,
            isVisiblePopUp: false,
        };
        _this.UIActions = {
            popup: {
                show: function (policy) {
                    _this.setState({ policy: policy });
                    _this.setState({ isVisiblePopUp: true });
                },
                hide: function () {
                    _this.setState({ policy: DEFAULT_POLICY });
                    _this.setState({ isVisiblePopUp: false });
                },
            },
        };
        return _this;
    }
    PrivacyPolicyList.prototype.componentDidMount = function () {
        this.props.onLoadPolicies();
    };
    PrivacyPolicyList.prototype.render = function () {
        var _this = this;
        var dataAndPrivacy = this.props.dataAndPrivacy;
        var crumbs = [
            { to: '/dataprivacy', text: 'Data & Privacy' },
            { to: '/dataprivacy/privacyList', text: 'Privacy Policy List' },
        ];
        return (_jsxs(PageWrapper, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Privacy and Policy List" }), _jsx("meta", { name: "description", content: "Privacy & Policy List" })] }), _jsx(PageHeader, { children: _jsx(PageHeaderTitle, { children: _jsx(Breadcrumbs, { crumbs: crumbs }) }) }), _jsxs(PageContent, { children: [_jsx(PasswordContentWrapper, { children: _jsx(BackContainer, { children: _jsx(BackContainerBox, { children: _jsx(Button, __assign({ type: "outline", onClick: function () { return _this.props.navigate(-1); }, iconLeft: faChevronLeft }, { children: "Back" })) }) }) }), _jsx(DataPrivacyBox, { children: _jsxs(DataPrivacyWrapper, { children: [_jsx(ConditionsModal, { title: this.state.policy.name, description: "Updated on: ".concat(moment(this.state.policy.created_at).format('YYYY-MM-DD')), content: this.state.policy.description, open: this.state.isVisiblePopUp, onOK: this.UIActions.popup.hide, onClose: this.UIActions.popup.hide }), _jsx(PolicyListTitle, { children: _jsxs("div", { children: [_jsx(P, __assign({ black: true, fontSize: 36, bold: true }, { children: "Privacy Policy List" })), _jsx(P, __assign({ center: true }, { children: "See the list of policies" }))] }) }), _jsx(PolicyListContent, {}), dataAndPrivacy.policies &&
                                        dataAndPrivacy.policies.length > 0 &&
                                        dataAndPrivacy.policies.map(function (policy) { return (_jsx(PolicyWrapper, { children: _jsxs(LatestPolicyWrapper, { children: [_jsxs(LatestPolicy, { children: [_jsx(LatestPolicyIndicator, { children: _jsx(P, __assign({ fontSize: 20, black: true }, { children: policy.name })) }), _jsx(P, __assign({ black: true }, { children: moment(policy.created_at).format('YYYY-MM-DD') }))] }), _jsxs(LatestPolicyDescriptionWrapper, { children: [_jsx(LatestPolicyDescription, { children: policy.description }), _jsx(Button, __assign({ type: "primary", onClick: function () { return _this.UIActions.popup.show(policy); } }, { children: "Read" }))] })] }) }, policy.name)); })] }) })] })] }));
    };
    return PrivacyPolicyList;
}(React.Component));
var mapStateToProps = createStructuredSelector({
    dataAndPrivacy: pageSelectors.makeDataAndPrivacyPageDomain(),
});
var mapDispatchToProps = function (dispatch) { return ({
    onLoadPolicies: function () {
        dispatch(pageActions.loadPolicies());
    },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
var withReducer = injectReducer({
    key: 'dataAndPrivacy',
    reducer: reducer,
});
var PrivacyPolicyListPageWrapper = function (props) {
    var params = useParams();
    var navigate = useNavigate();
    return (_jsx(ConnectedPrivacyPolicyListPage, __assign({ params: params, navigate: navigate }, props)));
};
var ConnectedPrivacyPolicyListPage = compose(withConnect, withReducer)(PrivacyPolicyList);
export default PrivacyPolicyListPageWrapper;
